export default () => ({
  entity: 'employee',
  employee: {
    staff_id: null,
    company_address_id: null
  }
})



// WEBPACK FOOTER //
// ./src/app/professional/company/employees/form/resources/data.js